import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import WLCustomModal from "./WLCustomModal";

const baseInputStyle = {
  width: "100%",
  height: "44px",
  padding: "0 14px",
  borderRadius: "8px",
  font: "inherit",
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
};

const inputStyle = (focused) => ({
  ...baseInputStyle,
  border: `1px solid ${focused ? "#2F4B9B" : "#ece7dd"}`,
  background: focused ? "#fff" : "#faf8f4",
});

const ConnectWithAgentModal = ({ visible, setVisible }) => {
  const [form, setForm] = useState({ fullName: "", phone: "", email: "" });
  const [focused, setFocused] = useState(null);

  const handleChange = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  return (
    <WLCustomModal
      visible={visible}
      setVisible={setVisible}
      btnText={"Request estate agent"}
      secondaryBtnText={"Cancel"}
      title={"Connect with a WELOCATE buying agent"}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography sx={{ fontSize: "14px", color: "#4a4f5e" }}>
          Tell us your shortlist and a senior buying agent in the area will
          reach out within 24 hours. No obligation, transparent fee.
        </Typography>

        <Box sx={{ display: "flex", gap: 2 }}>
          <input
            style={inputStyle(focused === "fullName")}
            placeholder="Full name"
            value={form.fullName}
            onChange={handleChange("fullName")}
            onFocus={() => setFocused("fullName")}
            onBlur={() => setFocused(null)}
          />
          <input
            style={inputStyle(focused === "phone")}
            placeholder="Phone"
            value={form.phone}
            onChange={handleChange("phone")}
            onFocus={() => setFocused("phone")}
            onBlur={() => setFocused(null)}
          />
        </Box>

        <input
          style={inputStyle(focused === "email")}
          placeholder="Email"
          type="email"
          value={form.email}
          onChange={handleChange("email")}
          onFocus={() => setFocused("email")}
          onBlur={() => setFocused(null)}
        />
      </Box>
    </WLCustomModal>
  );
};

export default ConnectWithAgentModal;
